import createTheme from '@mui/material/styles/createTheme';

import * as components from './components';
import baseTokens from './tokens';

const baseTheme = createTheme(baseTokens, { components });

export default baseTheme;
